import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { CuiMarketplaceSelector } from '../../../../connection-components/marketplace-selector';
import { LogService } from '../../../../services/log-service';

import style from './select-marketplace-modal.module.less';
import ModalPortal from '../../../../components/modal-portal';

const SelectMarketplaceModal = ({ onClose, onMarketplaceSelected }) => {
  return (
    <ModalPortal containerId='connect-marketplace-modal' onClose={onClose}>
      <Modal className={style['connect-marketplace-modal']}>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage defaultMessage='Connect a Store' description='connect generic marketplace title' id='51O8ze' />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <CuiMarketplaceSelector
            onError={(error) => {
              LogService.logInfo(error.code, error);
            }}
            onMarketplaceSelected={onMarketplaceSelected}
          />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

SelectMarketplaceModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onMarketplaceSelected: PropTypes.func.isRequired,
};

export default SelectMarketplaceModal;
